import { Link } from 'gatsby';
import React from 'react';
import styled from 'styled-components';

import ArrowRight from '../../icons/arrow-right.svg';

const CtaLink = (props) => {
  const {
    color,
    to,
    href,
    onClick,
    children,
    className,
    reverse = false
  } = props;

  if (onClick) {
    return (
      <StyledLink
        as="button"
        onClick={onClick}
        color={color}
        className={className}
      >
        {reverse && <StyledReverseArrowRight color={color} />}
        {children} {!reverse && <StyledArrowRight color={color} />}
      </StyledLink>
    );
  }

  if (href) {
    return (
      <StyledLink
        as="a"
        href={href}
        target="_blank"
        rel="noreferrer"
        color={color}
        className={className}
      >
        {reverse && <StyledReverseArrowRight color={color} />}
        {children} {!reverse && <StyledArrowRight color={color} />}
      </StyledLink>
    );
  }

  return (
    <StyledLink to={to} color={color} className={className}>
      {reverse && <StyledReverseArrowRight color={color} />}
      {children} {!reverse && <StyledArrowRight color={color} />}
    </StyledLink>
  );
};

const StyledLink = styled(Link)`
  appearance: none;
  background: none;
  border: none;
  color: ${({ color }) => color};
  cursor: pointer;

  display: inline-block;
  text-decoration: none;
`;

const StyledArrowRight = styled(ArrowRight)`
  margin-left: 5px;
  transition: all 0.2s linear;
  path {
    fill: ${({ color }) => color};
  }
  ${StyledLink}:hover &, ${StyledLink}:focus & {
    transform: translateX(5px);
  }
`;

const StyledReverseArrowRight = styled(ArrowRight)`
  margin-right: 5px;
  transition: all 0.2s linear;
  transform: translateX(0px) rotate(180deg);
  path {
    fill: ${({ color }) => color};
  }
  ${StyledLink}:hover &, ${StyledLink}:focus & {
    transform: translateX(-5px) rotate(180deg);
  }
`;

export default CtaLink;
